/* eslint-disable react-hooks/exhaustive-deps */
import { PackageHelmet } from '../../seo/package'
import { Event } from '../trackers/Tracking'
import { getPublicPackage, getSinglePhotographerPublicPackages } from 'apiCalls/PackageRequests'
import { getPackageForm } from 'apiCalls/PackageFormRequests'
import { PasedPackageFormData } from 'components/public/booking/contants'
import axios from 'axios'
import { SpinLoaderFullScreen } from 'components/Loader/SpinLoaderFullScreen'
import GenericCollapses from 'components/collapses/GenericCollapse'
import PublicHeader from 'components/public/PublicHeader'
import PublicPackageCarousel from 'components/public/PublicPackageCarousel'
import PublicRecommendedPackages from 'components/public/PublicRecommendedPackages'
import BookingRequestMiniSession from 'components/public/booking/BookingRequestMiniSession'
import { BookingRequestModal } from 'components/public/booking/BookingRequestModal'
import { useAppContext } from 'context/AppContext'
import React, { useEffect, useState } from 'react'
import ReactHtmlParser from 'react-html-parser'
import { IoIosArrowForward } from 'react-icons/io'
import ImgsViewer from 'react-images-viewer'
import styled, { css } from 'styled-components'
import { v4 as uuidv4 } from 'uuid'
// import { durationFormat } from 'variables/functions'
import { openInNewTab } from 'variables/functions'
import { PUBLIC_LINK_BASE } from 'variables/general'
import WebFont from 'webfontloader'

// import { Helmet } from 'react-helmet'

function PublicPackage(props) {
  const [pack, setPack] = useState(null)
  const [addOnsCart, setAddOnsCart] = useState([])
  const [otherPacks, setOtherPacks] = useState(null)
  const [images, setImages] = useState(null)
  const [description, setDescription] = useState(null)
  const [whatsIncluded, setWhatsIncluded] = useState(null)
  const [whatToExpect, setWhatToExpect] = useState(null)
  const [cancellationPolicy, setCancellationPolicy] = useState(null)
  const [context] = useAppContext()
  const source = axios.CancelToken.source()
  const [font, setFont] = useState(null)
  const [secondaryFont, setSecondaryFont] = useState(null)
  const [photographerBackground, setPhotographerBackground] = useState(null)
  const [currentImage, setCurrentImage] = useState(0)
  const [lightboxIsOpen, setLightboxIsOpen] = useState(false)
  const [open, setOpen] = useState(true)
  const [values, setValues] = useState({
    date: '',
    name: '',
    email: '',
    note: '',
    time: null,
    phone: '',
    placeholderMessage: '',
  })
  const [loadComplete, setLoadComplete] = useState(false)
  const [deposit, setDeposit] = useState(null)
  const [openMobileContactModal, setOpenMobileContactModal] = useState(false)
  const defaultColor = {
    text: '#191919',
    background: '#fff',
    accent1: '#191919',
    accent2: 'rgb(250, 250, 250)',
    accent3: '#ccc',
  }
  const [packageForm, setPackageForm] = useState([])

  useEffect(() => {
    if (pack) {
      if (pack.description) {
        let CleanText1 = pack.description.replace(/(<\/h1>|<\/h2>|<\/h3>|<\/h4>|<\/h5>|<\/h6>)/g, '</p>')
        let CleanText2 = CleanText1.replace(/(<h1>|<h2>|<h3>|<h4>|<h5>|<h6>)/g, '<p>')
        setDescription(CleanText2)
      }
      if (pack.whatsIncluded) {
        let IncludeText1 = pack.whatsIncluded.replace(/(<\/h1>|<\/h2>|<\/h3>|<\/h4>|<\/h5>|<\/h6>)/g, '</p>')
        let IncludeText2 = IncludeText1.replace(/(<h1>|<h2>|<h3>|<h4>|<h5>|<h6>)/g, '<p>')

        let IncludeText3 = IncludeText2.replace(/(<\/a><\/p>)/g, '</a>')
        let IncludeText4 = IncludeText3.replace(/(<p><a)/g, '<a')

        setWhatsIncluded(IncludeText4)
      }
      if (pack.whatToExpect) {
        let expectText1 = pack.whatToExpect.replace(/(<\/h1>|<\/h2>|<\/h3>|<\/h4>|<\/h5>|<\/h6>)/g, '</p>')
        let expectText2 = expectText1.replace(/(<h1>|<h2>|<h3>|<h4>|<h5>|<h6>)/g, '<p>')

        setWhatToExpect(expectText2)
      }
      if (pack.cancellationPolicy) {
        let cancellationText1 = pack.cancellationPolicy.replace(
          /(<\/h1>|<\/h2>|<\/h3>|<\/h4>|<\/h5>|<\/h6>)/g,
          '</p>',
        )
        let cancellationText2 = cancellationText1.replace(/(<h1>|<h2>|<h3>|<h4>|<h5>|<h6>)/g, '<p>')
        setCancellationPolicy(cancellationText2)
      }
    }
  }, [pack])

  useEffect(() => {
    const { identifier } = props.match.params

    getPublicPackage(identifier).then((response) => {
      if (response.status === 200) {
        Event('View', 'Package Viewed', `URL Path of Package - ${window.location.href}`)

        setPack(response.data)
        setAddOnsCart(response.data.linkedAddOns.map((addon) => ({ ...addon, addedToOrder: false })))
        setImages(response.data.images)

        getPackageForm(response.data.identifier).then((res) => {
          if (res.data.results.length === 0) {
            setPackageForm(PasedPackageFormData)
          } else {
            setPackageForm(res.data.results.sort((a, b) => a.orderPosition - b.orderPosition))
          }
        })

        const displayFont = response.data.photographer.displayFont
        setFont(displayFont)
        setSecondaryFont(response.data.photographer.secondaryFont)

        const basicFonts = [
          'Tahoma',
          'Georgia',
          'Arial',
          'Helvetica',
          'Trebuchet MS',
          'Verdana',
          'Times New Roman',
          'Times',
          'Courier New',
          'Segoe UI',
        ]

        if (!basicFonts.includes(displayFont) && !!displayFont) {
          WebFont.load({
            google: {
              families: !!response.data.photographer.secondaryFont
                ? [displayFont, response.data.photographer.secondaryFont]
                : [displayFont],
            },
          })
        }
        let currentPackage = response.data
        setPhotographerBackground(response.data.photographer.backgroundColor)
        getSinglePhotographerPublicPackages(response.data.photographer.identifier).then((response) => {
          if (response.status === 200) {
            let packages = response.data
              .filter((pack) => {
                return pack.identifier !== currentPackage.identifier
              })
              .filter((pack) => pack.status === 1)

            let packsRelatedByTag = packages.filter((pack) => {
              let anyRelation = currentPackage.priorityTags.some((baseTag) => {
                let isRelated = pack.priorityTags.some((tag) => {
                  return tag.tag === baseTag.tag && tag.tag !== 'all'
                })
                return isRelated
              })
              return anyRelation
            })

            if (packsRelatedByTag.length !== 0) {
              setOtherPacks(packsRelatedByTag.slice(0, 4))
            } else {
              setOtherPacks(packages.slice(0, 4))
            }
          } else {
            setTimeout(() => {
              window.location.href = `/`
            }, 1000)
            throw new Error(response.data)
          }
        })
      } else {
        if (response.status === 404) {
          window.location.href = `/`
        } else {
          setTimeout(() => {
            window.location.href = `/`
          }, 1000)
          throw new Error(response.data)
        }
      }
    })
  }, [])

  useEffect(() => {
    if (pack) {
      const depositDue =
        parseFloat(pack.depositFraction) === 1
          ? pack.price
          : pack.depositFraction
          ? pack.price * parseFloat(pack.depositFraction)
          : parseFloat(pack.paymentSchedule) === 0
          ? pack.price
          : pack.price * 0.5
      setDeposit(depositDue)

      // MAKE SURE CUSTOM FAVICON IS UPLOADED
      if (pack.photographer.faviconImage) {
        const favicon = document.getElementById('favicon')
        favicon.href = pack.photographer.faviconImage
      }
    }
  }, [pack])

  const closeLightbox = () => {
    setLightboxIsOpen(false)
    setCurrentImage(0)
  }
  const gotoPrevious = () => {
    setCurrentImage(currentImage - 1)
  }
  const gotoNext = () => {
    setCurrentImage(currentImage + 1)
  }

  const handleChange = (event) => {
    event.persist()
    setValues((values) => ({
      ...values,
      [event.target.name]: event.target.value,
    }))
  }

  const handleChangeWithPackageForm = (e, index) => {
    const newContactForm = packageForm.map((el, i) => {
      if (index === Number(i)) {
        return { ...el, fieldValue: e.target.value }
      }
      return el
    })

    setPackageForm(newContactForm)
  }

  // COMMENT
  // CHECKING TO SEE EVERYTHING IS LOADED
  const loadingComplete = pack && images

  // GOD AWFUL BUT ONLY WAY TO REFERENCE HOME SITE URL
  const socialSiteURL =
    pack &&
    pack.photographer &&
    pack.photographer.socials.filter((item) => item.socialSite.description === 'Website URL Link')[0] &&
    pack.photographer.socials.filter((item) => item.socialSite.description === 'Website URL Link')[0].url

  let galleryImages
  if (images) {
    let imagesCopy = [...images]
    imagesCopy.shift()
    let landscapeGalleryImages = imagesCopy.filter(
      (img) => img.dimensions.width / img.dimensions.height >= 1.4,
    )
    let otherImages = imagesCopy.filter((img) => img.dimensions.width / img.dimensions.height < 1.4)
    galleryImages = [...landscapeGalleryImages, ...otherImages]
  }

  return !loadingComplete ? (
    <div>
      {' '}
      <SpinLoaderFullScreen />
    </div>
  ) : (
    <OuterContainer background={photographerBackground} font={font} fontcolor={pack.photographer.fontColor}>
      {/* <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet> */}
      <PackageHelmet
        pack={pack}
        location={props.history.location}
        image={images[0].mobileThumbnail || images[0].thumbnail}
      />
      <MobileModal open={openMobileContactModal}>
        <BookingSection mobile>
          <MobileLabel>
            Booking
            <CloseButton
              type="button"
              onClick={() => {
                setOpenMobileContactModal(false)
              }}
            >
              <CloseSpan1 />
              <CloseSpan2 />
            </CloseButton>
          </MobileLabel>
          {!!pack.miniSessions && !(pack.photographer.activeSubscriptionName === 'Website Plan') ? (
            <BookingRequestMiniSession
              values={values}
              setValues={setValues}
              addOns={addOnsCart}
              setAddOns={setAddOnsCart}
              handleChange={handleChange}
              id={props.match.params.identifier}
              pack={pack}
              loadComplete={loadComplete}
              deposit={deposit}
              packageForm={packageForm}
              handleChangeWithPackageForm={handleChangeWithPackageForm}
            />
          ) : (
            <BookingRequestModal
              open={open}
              setOpen={setOpen}
              values={values}
              setValues={setValues}
              addOns={addOnsCart}
              setAddOns={setAddOnsCart}
              handleChange={handleChange}
              pack={pack}
              loadComplete={loadComplete}
              setLoadComplete={setLoadComplete}
              location={props.history.location}
              source={source}
              type={'public'}
              background={photographerBackground}
              marketplace={false}
              colorObj={defaultColor}
              packageForm={packageForm}
              handleChangeWithPackageForm={handleChangeWithPackageForm}
            />
          )}
        </BookingSection>
      </MobileModal>
      <PublicHeader
        photographer={pack.photographer}
        coverPhoto={
          pack.photographer.coverImage.length
            ? context.isMobile
              ? pack.photographer.coverImage[0].thumbnail
              : pack.photographer.coverImage[0].image
            : pack?.images?.[0]?.image
        }
        page="package"
        font={font}
        secondaryFont={secondaryFont}
      />
      <Container>
        <BreadCrumb>
          {socialSiteURL && (
            <React.Fragment>
              <BreadCrumbItem href={`${socialSiteURL}`} fontcolor={pack.photographer.fontColor}>
                Home
              </BreadCrumbItem>
              <BreadCrumbArrow fontcolor={pack.photographer.fontColor} />
            </React.Fragment>
          )}
          <BreadCrumbItem
            href={`/portfolio/${pack.photographer.identifier}`}
            fontcolor={pack.photographer.fontColor}
          >
            Packages
          </BreadCrumbItem>

          <BreadCrumbArrow fontcolor={pack.photographer.fontColor} />
          <BreadCrumbItem href="?" fontcolor={pack.photographer.fontColor}>
            {pack.title}
          </BreadCrumbItem>
        </BreadCrumb>
        <Title>{pack.title}</Title>
        <ImgGallery>
          <ImgsViewer
            imgs={images.map((el) => {
              return {
                src: el.image,
                width: el.dimensions.width,
                height: el.dimensions.height,
              }
            })}
            currImg={currentImage}
            isOpen={lightboxIsOpen}
            onClickPrev={gotoPrevious}
            onClickNext={gotoNext}
            onClose={closeLightbox}
          />
          {window.innerWidth > 600 && galleryImages.length > 3 && (
            <GalleryColumn>
              {galleryImages.slice(0, 3).map((el, i) => {
                return (
                  <ColumnImg
                    src={el.thumbnail}
                    key={uuidv4()}
                    onClick={() => {
                      setCurrentImage(
                        images.findIndex((image) => image.identifier === galleryImages[i].identifier),
                      )
                      setLightboxIsOpen(true)
                    }}
                  />
                )
              })}
            </GalleryColumn>
          )}
          <PublicPackageCarousel
            items={images}
            pack={pack}
            video={pack && pack.videoUrl}
            openLightbox={(index) => {
              setCurrentImage(index)
              setLightboxIsOpen(true)
            }}
          />
        </ImgGallery>
        <Row1>
          {window.innerWidth <= 700 && (
            <PackageInfo>
              <H3>
                {' '}
                {pack.startingAt ? 'Starting at ' : ''}
                {pack?.photographer?.overrideCurrencySymbol ?? pack.photographer.currencySymbol}
                {~~pack.price}{' '}
                <Small>
                  {pack?.photographer?.overrideCurrencyCode ?? pack?.photographer?.currencyCode ?? ''}
                </Small>
              </H3>
              <OpenButton2
                onClick={() => {
                  setOpenMobileContactModal(true)
                }}
              >
                {!pack.miniSessions || pack.photographer.activeSubscriptionName === 'Website Plan'
                  ? 'Request Booking'
                  : 'Book Now'}
              </OpenButton2>
            </PackageInfo>
          )}
          <ContentColumn>
            {whatsIncluded && <H5>What's Included</H5>}
            {whatsIncluded && <HTMLWrap>{ReactHtmlParser(whatsIncluded)}</HTMLWrap>}
            {description !== ('<p><br></p>' || '<p></p>') ? <H5>Package Description</H5> : null}
            {description !== ('<p><br></p>' || '<p></p>') && (
              <HTMLWrap>{ReactHtmlParser(description)}</HTMLWrap>
            )}
            {whatToExpect !== ('<p><br></p>' || '<p></p>') && <H5>What to Expect</H5>}
            {whatToExpect !== ('<p><br></p>' || '<p></p>') && (
              <HTMLWrap>{ReactHtmlParser(whatToExpect)}</HTMLWrap>
            )}
            {pack.faqs && pack.faqs.length > 0 && <H5>FAQs</H5>}
            {pack.faqs &&
              pack.faqs.length > 0 &&
              pack.faqs.map((faq) => (
                <GenericCollapses
                  key={faq.identifier}
                  header={faq.question}
                  $fontSize={'1.6em'}
                  body={faq.answer}
                  fontcolor={pack.photographer.fontColor}
                />
              ))}
            <H5>Policies</H5>
            {pack.cancellationPolicy && (
              <GenericCollapses
                header="Cancellation Policy"
                body={
                  <React.Fragment>
                    <CardBody>{ReactHtmlParser(cancellationPolicy)}</CardBody>
                  </React.Fragment>
                }
                $fontSize={'1.6em'}
                fontcolor={pack.photographer.fontColor}
              />
            )}
            {pack.weatherPolicy && (
              <GenericCollapses
                header={'Weather Policy'}
                body={
                  <React.Fragment>
                    <CardBody>{pack.weatherPolicy}</CardBody>
                  </React.Fragment>
                }
                $fontSize={'1.6em'}
                fontcolor={pack.photographer.fontColor}
              />
            )}
            <GenericCollapses
              header={'License Policy'}
              body={
                <React.Fragment>
                  <CardBody>{pack.licensePolicy}</CardBody>
                </React.Fragment>
              }
              $fontSize={'1.6em'}
              fontcolor={pack.photographer.fontColor}
            />
            {pack.extensionPolicy && (
              <GenericCollapses
                header={'Extension Policy'}
                body={
                  <React.Fragment>
                    <CardBody>{pack.extensionPolicy}</CardBody>
                  </React.Fragment>
                }
                $fontSize={'1.6em'}
                fontcolor={pack.photographer.fontColor}
              />
            )}
            {pack.addOnsPolicy && (
              <GenericCollapses
                header={'Additional Policies'}
                body={
                  <React.Fragment>
                    <CardBody>{pack.addOnsPolicy}</CardBody>
                  </React.Fragment>
                }
                $fontSize={'1.6em'}
                fontcolor={pack.photographer.fontColor}
              />
            )}
            {pack.paymentSchedulePolicy && (
              <GenericCollapses
                header={'Payment Policy'}
                body={
                  <React.Fragment>
                    <CardBody>{pack.paymentSchedulePolicy}</CardBody>
                  </React.Fragment>
                }
                $fontSize={'1.6em'}
                fontcolor={pack.photographer.fontColor}
              />
            )}
          </ContentColumn>
          <Column1Header>
            {window.innerWidth > 700 && (
              <PackageInfo>
                <H3>
                  {' '}
                  {pack.startingAt ? 'Starting at ' : ''}
                  {pack?.photographer?.overrideCurrencySymbol ?? pack.photographer.currencySymbol}
                  {~~pack.price}{' '}
                  <Small>
                    {pack?.photographer?.overrideCurrencyCode ?? pack?.photographer?.currencyCode ?? ''}
                  </Small>
                </H3>
              </PackageInfo>
            )}
            {window.innerWidth > 700 && (
              <BookingSection>
                <BlackLabel>Interested in booking?</BlackLabel>
                {!!pack.miniSessions && !(pack.photographer.activeSubscriptionName === 'Website Plan') ? (
                  <BookingRequestMiniSession
                    values={values}
                    setValues={setValues}
                    addOns={addOnsCart}
                    setAddOns={setAddOnsCart}
                    handleChange={handleChange}
                    id={props.match.params.identifier}
                    pack={pack}
                    loadComplete={loadComplete}
                    deposit={deposit}
                    font={font}
                    secondaryFont={secondaryFont}
                    packageForm={packageForm}
                    handleChangeWithPackageForm={handleChangeWithPackageForm}
                  />
                ) : (
                  <BookingRequestModal
                    open={open}
                    addOns={addOnsCart}
                    setAddOns={setAddOnsCart}
                    setOpen={setOpen}
                    values={values}
                    setValues={setValues}
                    handleChange={handleChange}
                    pack={pack}
                    loadComplete={loadComplete}
                    setLoadComplete={setLoadComplete}
                    location={props.history.location}
                    source={source}
                    type={'public'}
                    background={photographerBackground}
                    marketplace={false}
                    colorObj={defaultColor}
                    packageForm={packageForm}
                    handleChangeWithPackageForm={handleChangeWithPackageForm}
                  />
                )}
              </BookingSection>
            )}
          </Column1Header>
        </Row1>
        {window.innerWidth < 1100 && (
          <PhotographerSection
            onClick={() =>
              openInNewTab(`${PUBLIC_LINK_BASE(pack.photographer)}/portfolio/${pack.photographer.identifier}`)
            }
          >
            <Link>
              <Row>
                <CompanyImage src={pack.photographer.displayImage} />
                <PhotographerName>{pack.photographer.name}</PhotographerName>
              </Row>
            </Link>
          </PhotographerSection>
        )}
      </Container>
      {window.innerWidth <= 700 && !openMobileContactModal && (
        <MobileContact>
          Interested in booking?{' '}
          <OpenButton
            onClick={() => {
              setOpenMobileContactModal(true)
            }}
          >
            {!pack.miniSessions || pack.photographer.activeSubscriptionName === 'Website Plan'
              ? 'Request Booking'
              : 'Book Now'}
          </OpenButton>
        </MobileContact>
      )}
      {otherPacks && otherPacks.length !== 0 && (
        <PublicRecommendedPackages otherpacks={otherPacks} pack={pack} />
      )}
      {otherPacks &&
      otherPacks.length === 0 &&
      pack.photographer &&
      pack.photographer.activeSubscription === undefined ? (
        <FooterImg alt="public footer image" src={pack.photographer.companyImage} />
      ) : null}
    </OuterContainer>
  )
}

export default PublicPackage

PublicPackage.propTypes = {}

const OuterContainer = styled.div`
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 4em;
  background: ${(props) => props.background && props.background};
  font-family: ${(props) => props.font && props.font};
  color: ${(props) => (props.fontcolor ? props.fontcolor : 'var(--black')};
`

const MobileModal = styled.div`
  display: ${(props) => (props.open ? 'block' : 'none')};
  overflow: auto;
  width: 100%;
  height: 100%;
  background: #fafafa;
  border: 0.5px solid rgba(118, 118, 118, 0.28);
  box-shadow: rgba(0, 0, 0, 0.15) 0px 10px 37px;
  white-space: normal;
  z-index: 998;
  top: 0;
  position: fixed;
  left: 0;
`

const ImgGallery = styled.div`
  display: flex;
  margin: 20px 0 40px 0;
  height: 74vh;
  max-width: 1600px;
  width: 90vw;
  @media (max-width: 1350px) {
    flex-direction: column-reverse;
    width: 90vw;
    height: auto;
  }
  @media (max-width: 576px) {
    margin: 0;
  }
`

const Row1 = styled.div`
  display: flex;
  justify-content: center;
  @media (max-width: 1350px) {
    width: 90vw;
  }
  @media (max-width: 700px) {
    flex-direction: column;
  }
`

const H3 = styled.h3`
  font-size: 2.3em;
  line-height: 1.5;
  font-weight: 600;

  @media (max-width: 700px) {
    font-size: 2em;
    font-weight: 550;
  }
  @media (max-width: 600px) {
    font-size: 2.3em;
  }
`

// const H4 = styled.h4`
//   font-size: 1.6em;
//   color: var(--black);
//   line-height: 1.5;
//   font-weight: 600;
//   margin: 0 0 calc(1em / 1.6) 0;
//   font-family: ${(props) => props.font && props.font};
//   @media (max-width: 700px) {
//     font-weight: 500;
//     font-size: 1.6em;
//   }
//   @media (max-width: 600px) {
//     font-size: 1.8em;
//     margin: 0 0 calc(1em / 2.6) 0;
//   }
// `

const H5 = styled.div`
  font-size: 26px;
  font-weight: 500;
  line-height: 1.5;
  @media (max-width: 500px) {
    font-size: 22px;
    line-height: 1;
  }
`

// const P = styled.p`
//   text-align: justify;
//   font-size: 1.5em;
//   margin: 0 0 calc(1em / 1.8) 0;
//   text-align: left;
//   line-height: 1.7;
//   color: #717171;
//   font-family: ${(props) => props.font && props.font};
//   @media (max-width: 700px) {
//     font-size: 1.4em;
//     line-height: 1;
//   }
//   @media (max-width: 600px) {
//     font-size: 1.6em;
//     margin: 0 0 calc(1em / 2.6) 0;
//   }
// `

const ContentColumn = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: 10px;
  margin: 0 20px;
  @media (max-width: 1200px) {
    margin: 0 20px 0 20px;
  }
  @media (max-width: 1120px) {
    margin: 0 40px 0 5px;
  }
  @media (max-width: 700px) {
    margin: 0 10px;
    width: auto;
  }
`

const HTMLWrap = styled.div`
  margin: 1em 0 2em 0;
  font-size: 16px;
  line-height: 1.7;
  & a {
    color: #1870f0;
    text-decoration: underline;
  }
`

const Column1Header = styled.div`
  position: relative;
  width: 100%;
  font-size: 10px;
  padding: 0 0 1em 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 500px) {
    font-size: 8px;
  }
`

const MobileContact = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  bottom: 0;
  position: fixed;
  z-index: 999;
  height: 70px;
  width: 100%;
  font-size: 18px;
  padding: 0 40px 0 20px;
  background-color: var(--black);
  border-top: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
  color: #fff;
  @media (max-width: 400px) {
    padding: 0 20px;
  }
`

const OpenButton = styled.button`
  font-size: 0.8em;
  padding: 1em;
  background-color: #fff;
  color: var(--black);
`

const OpenButton2 = styled.button`
  font-size: 14px;
  padding: 1em;
  background-color: black;
  color: white;
`

const PublicPackageCarouselWrapper = styled.div`
  -webkit-touch-callout: none !important;
  -webkit-user-select: none !important;
  -khtml-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
  -webkit-tap-highlight-color: transparent !important;
  @media (max-width: 1300px) {
    font-size: 9px;
  }
  @media (max-width: 1000px) {
    font-size: 12px;
  }
  @media (max-width: 900px) {
    font-size: 11px;
  }
  @media (max-width: 800px) {
    font-size: 10px;
  }
  @media (max-width: 730px) {
    font-size: 9px;
    margin-bottom: 20px;
  }
  @media (max-width: 660px) {
    font-size: 8px;
  }
  @media (max-width: 600px) {
    font-size: 7px;
  }
  @media (max-width: 520px) {
    font-size: 6px;
  }
  @media (max-width: 430px) {
    font-size: 5.5px;
  }
  @media (max-width: 400px) {
    font-size: 5px;
  }
  @media (max-width: 360px) {
    font-size: 4.5px;
  }
  @media (max-width: 330px) {
    font-size: 4px;
  }
`
const Title = styled.div`
  margin: 5px 0;
  max-width: 1600px;
  width: 88%;
  font-size: 28px;
  @media (max-width: 1500px) {
    width: 90%;
  }
  @media (max-width: 1300px) {
    width: 95%;
  }
  @media (max-width: 1100px) {
    width: 97%;
  }
  @media (max-width: 600px) {
    font-size: 26px;
    margin: 5px 0 10px 0;
  }
`

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 90vw;
  max-width: 1700px;
  min-height: 100vh;
  margin: 0 0 3em 0;
  @media (max-width: 1100px) {
    flex-wrap: wrap;
    & ${Column1Header} {
      padding: 1em 0;
    }
    & ${PublicPackageCarouselWrapper} {
      width: 100%;
    }
  }
  @media (max-width: 600px) {
    & ${Column1Header}, ${Row1} {
      font-size: 9px;
    }
  }
  @media (max-width: 500px) {
    & ${Column1Header} {
      font-size: 8px;
    }
  }
  @media (max-width: 450px) {
    & ${Column1Header} {
      font-size: 7px;
    }
  }
  @media (max-width: 400px) {
    & ${Column1Header} {
      font-size: 6px;
    }
  }
  @media (max-width: 350px) {
    & ${Column1Header} {
      font-size: 5px;
    }
  }
`

const Small = styled.small`
  font-size: 80%;
  font-weight: 450;
`

const CardBody = styled.div`
  flex: 1 1 auto;
`

const BreadCrumb = styled.div`
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 70px 0 20px 0;
  color: inherit;
  @media (max-width: 900px) {
    margin: 30px 0;
  }
  @media (max-width: 600px) {
    margin: 30px 0 10px 0;
  }
`

const BreadCrumbItem = styled.a`
  text-decoration: none;
  color: ${(props) => (props.fontcolor ? props.fontcolor : 'var(--black)')};
  padding: 0 0 3px 0;
  font-weight: 400;
  @media (max-width: 600px) {
    margin: 5px 0;
    font-size: 14px;
  }
`

const BreadCrumbArrow = styled(IoIosArrowForward)`
  color: ${(props) => (props.fontcolor ? props.fontcolor : 'var(--black)')};
  margin: 0 10px 3px 10px;
  @media (max-width: 600px) {
    font-size: 12px;
  }
`

const FooterImg = styled.img`
  margin: 50px 0 25px 0;
  width: 80px;
  border-radius: 10px;
`

const PhotographerSection = styled.div`
  width: 68em;
  padding: 16px;
  background-color: var(--background-grey);
  color: var(--black);
  cursor: pointer;
  @media (max-width: 1100px) {
    padding: 30px 0 30px 0;
    border-top: none;
    width: 100%;
  }
`

const Row = styled.div`
  display: flex;
  padding: 8px;
  ${(props) =>
    props.margin &&
    css`
      margin: 2.1em 0 0 0;
      @media (max-width: 1100px) {
        margin: 1em 0 0 0;
      }
    `}
`

const BookingSection = styled.div`
  color: var(--black);
  width: 540px;
  border: 1px solid var(--light-grey);
  background-color: var(--background-grey);
  padding: 15px;
  box-shadow: 0 1px 5px rgb(0 0 0 / 5%);
  @media (min-width: 700px) {
    position: -webkit-sticky;
    position: sticky;
    top: 10px;
  }
  @media (max-width: 1200px) {
    width: 500px;
  }
  @media (max-width: 1100px) {
    width: 450px;
  }
  @media (max-width: 900px) {
    width: 400px;
  }
  @media (max-width: 800px) {
    width: 370px;
  }
  @media (max-width: 700px) {
    width: 100%;
    border: none;
    box-shadow: none;
  }
`

const PackageInfo = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fafafa;
  width: 540px;
  margin: 0 0 20px 0;
  padding: 15px;
  box-shadow: 0 1px 5px rgb(0 0 0 / 5%);
  justify-content: space-between;
  color: var(--black);
  @media (max-width: 1200px) {
    width: 500px;
  }
  @media (max-width: 1100px) {
    width: 450px;
  }
  @media (max-width: 900px) {
    width: 400px;
  }
  @media (max-width: 800px) {
    width: 370px;
  }
  @media (max-width: 700px) {
    width: 100%;
    flex-direction: row;
  }
`

const BlackLabel = styled.div`
  background-color: var(--black);
  color: #fff;
  font-size: 24px;
  font-weight: 400;
  padding: 20px 0 20px 15px;
  margin: 0 0 10px 0;
  border-radius: 0.3em;
  letter-spacing: 0.5px;
`

const MobileLabel = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 24px;
  font-weight: 550;
  padding: 20px 0;
  margin: 0 0 20px 0;
  border-bottom: 1px solid #dddddd;
`

const CloseButton = styled.button`
  font-size: 1.25rem;
  background-color: initial;
  border: 1px solid transparent;
  color: rgba(0, 0, 0, 0.6);
  border-color: transparent;
  text-align: right;
  overflow: visible;
  @media (max-width: 991.98px) {
    width: 20px;
    height: 20px;
    position: static;
    cursor: pointer;
  }
  &:hover {
    color: #000;
    border-radius: 8px;
  }
`

const CloseSpan1 = styled.span`
  display: block;
  position: absolute;
  width: 16px;
  height: 2px;
  border-radius: 2px;
  opacity: 1;
  background: #283448;
  transform: rotate(135deg);
  right: 20px;
`

const CloseSpan2 = styled(CloseSpan1)`
  transform: rotate(-135deg);
`

const CompanyImage = styled.img`
  height: 80px;
  width: 80px;
  border-radius: 40px;
  object-fit: cover;
  @media (max-width: 1100px) {
    height: 70px;
    width: 70px;
    border-radius: 35px;
  }
`

const PhotographerName = styled.h3`
  margin: 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 0 0 0 0.8em;
  @media (max-width: 1100px) {
    font-size: 1.2em;
  }
`

const Link = styled.div``

const GalleryColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: auto;
  margin: 0 1vh 0 0;
  width: 420px;
  @media (max-width: 1500px) {
    width: 400px;
  }
  @media (max-width: 1400px) {
    width: 375px;
  }
  @media (max-width: 1350px) {
    flex-direction: row;
    margin: 1.5vw 0 0 0;
  }
`

const ColumnImg = styled.img`
  width: auto;
  height: 24vh;
  cursor: pointer;
  margin: 0;
  padding: 0;
  object-fit: cover;
  @media (max-width: 1350px) {
    width: 29vw;
    height: calc(29vw * 2 / 3);
  }
`
